import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Bredcrumb from "../../Bredcrumb/Main";
import PD_1 from "../../../assets/images/pd_1.jpg";
import PD_2 from "../../../assets/images/pd_2.jpg";
import PD_3 from "../../../assets/images/pd_3.jpg";
import BGImg from "../../../assets/images/bread_crumb_bg.svg";
import BGImg1 from "../../../assets/images/bread_crumb_bg_one.png";
import BGImg2 from "../../../assets/images/bread_crumb_bg_two.png";

const Main = ({ brdcum }) => {
  const [faqCategory, setFaqCategory] = useState([]);
  const [activeFaq, setActiveFaq] = useState({});
  useEffect(() => {
    // fetch(`${process.env.REACT_APP_URL_API}/faq`, { method: "POST" })
    //   .then((res) => res.json())
    //   .then((data) => {
    //     setFaqCategory(data.faq);
    //   });

    const data = {
      faq: [
        {
          category: "App",
          is_active: true,
          _id: "6477868b99f0f32c7a1ac6ed",
          display_name: "Paso 1.",
          questions: [
            {
              answer:
                "- Iniciar session en la App de  PagoDirecto App y luego  tocar sobre el nombre de usuario.",
              question:
                "Iniciar session en la App de  PagoDirecto App y luego  tocar sobre el nombre de usuario",
            },
          ],
          created_at: "2023-07-10T09:00:00.000Z",
        },
        {
          category: "Apps",
          is_active: true,
          _id: "6477868b99f0f32c7a1ac6ss",
          display_name: "Paso 2.",
          questions: [
            {
              answer:
                "- Iniciar session en la App de  PagoDirecto App y luego  tocar sobre el nombre de usuario.",
              question: "Tap [Legal] - [Eliminar cuenta].",
            },
          ],
          created_at: "2023-07-10T09:00:00.000Z",
        },
        {
          category: "Wallet",
          is_active: true,
          _id: "6477868b99f0f32c7a1ac6es",
          display_name: "Paso 2.",
          questions: [
            {
              answer:
                "Es una billetera virtual que te permitirá tener fondos dentro de la app y realizar pagos en todas las funciones y servicios que estén disponibles.",
              question: "¿Qué es?",
            },
            {
              answer:
                "Puedes depositar fondos desde distintos métodos: \n</br>- Pago móvil.\n</br>- Tarjetas Nacionales.\n</br> - Tarjetas Internacionales.\n</br> - Transferencias bancarias",
              question: "¿Cómo puedo depositar dinero en mi wallet?",
            },
          ],
          created_at: "2023-07-10T09:00:00.000Z",
        },
      ],
    };
    setFaqCategory(data.faq);
  }, []);

  return (
    <>
      {brdcum.b1 && (
        <Bredcrumb
          no={1}
          title="Términos y Condiciones de PagoDirecto"
          paragraph=" "
          tag=""
          bgimg={BGImg}
        />
      )}

      <section className="row_am faq_section">
        <div className="container">
          <div className="faq_panel">
            <div className="card my-5" data-aos-duration="1500">
              <div
                className="card-header"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <div className="mb-4">
                  <p>
                    <strong>Fecha de Última Actualización: 29 de julio de 2025</strong>
                  </p>
                  
                  <p>
                    Bienvenido/a a PagoDirecto. Al descargar, instalar o utilizar nuestra aplicación móvil ("la Aplicación" o "PagoDirecto"), usted ("el Usuario") acepta los presentes Términos y Condiciones de Uso, nuestra Política de Privacidad, y cualquier otra política o directriz que podamos publicar ocasionalmente. Si no está de acuerdo con estos Términos, por favor, no utilice la Aplicación. Su uso implica la aceptación total de estos términos.
                  </p>
                </div>

                <div className="mb-4">
                  <h2
                    className="mb-3 btn  "
                    style={{ textAlign: "left", alignSelf: "flex-start" }}
                  >
                    1. SOBRE PAGODIRECTO
                  </h2>
                  <p>
                    PagoDirecto es una Súper App multibanco y multifunción que digitaliza y optimiza flujos de pagos para comercios y personas en Venezuela. Nuestra misión es simplificar sus transacciones diarias y brindarle bienestar, permitiéndole pagar todo en un solo lugar de forma rápida, segura y conveniente.
                  </p>
                </div>

                <div className="mb-4">
                  <h2
                    className="mb-3 btn  "
                    style={{ textAlign: "left", alignSelf: "flex-start" }}
                  >
                    2. REGISTRO DE CUENTA
                  </h2>
                  <p>
                    <strong>2.1.</strong> Para utilizar los servicios de PagoDirecto, el Usuario deberá crear una cuenta personal en la Aplicación, proporcionando información veraz, completa y actualizada.
                  </p>
                  <p>
                    <strong>2.2.</strong> El Usuario es responsable de mantener la confidencialidad de su contraseña y de todas las actividades que ocurran bajo su cuenta. PagoDirecto no será responsable por cualquier pérdida o daño derivado del uso no autorizado de su cuenta.
                  </p>
                  <p>
                    <strong>2.3.</strong> PagoDirecto se reserva el derecho de rechazar cualquier solicitud de registro o cancelar una cuenta existente si se detecta información falsa, actividades sospechosas o incumplimiento de estos Términos, sin que ello genere derecho a reclamo o indemnización, salvo que se demuestre error imputable a PagoDirecto.
                  </p>
                </div>

                <div className="mb-4">
                  <h2
                    className="mb-3 btn  "
                    style={{ textAlign: "left", alignSelf: "flex-start" }}
                  >
                    3. SERVICIOS OFRECIDOS (VERTICALES)
                  </h2>
                  <p>
                    PagoDirecto ofrece una variedad de servicios de pago y gestión digital. A continuación, se detallan las condiciones específicas para cada vertical:
                  </p>

                  <div>
                    < h6 className="mb-2" style={{ fontWeight: "bold" }}>
                      3.1. Estacionamientos (Parking):
                    </  h6>
                    <ul className="pl-3" style={{ paddingLeft: "", listStyleType: "disc" }}>
                      <li className="mb-2">
                        <strong>3.1.a.</strong> Permite el acceso y salida de estacionamientos aliados utilizando tecnología Bluetooth (BLE) y/o QR.
                      </li>
                      <li className="mb-2">
                        <strong>3.1.b.</strong> Facilita el pago de tickets de estacionamiento de forma digital, eliminando la necesidad de tickets físicos o taquillas presenciales.
                      </li>
                      <li className="mb-2">
                        <strong>3.1.c</strong> El pago incluirá la tarifa del estacionamiento más un fee de servicio de PagoDirecto, equivalente a cero dólares con cuarenta centavos estadounidenses (USD 0,40) por cada transacción.
                      </li>
                      <li className="mb-2">
                        <strong>3.1.d</strong> El usuario deberá activar el Bluetooth como requisito esencial para el funcionamiento del acceso/salida en estacionamientos compatibles.
                      </li>
                    </ul>

                    <h6 className="mb-2" style={{ fontWeight: "bold" }}>
                      3.2. Servicios (Telecomunicaciones y Otros):
                    </h6>
                    <ul className="pl-3" style={{ paddingLeft: "", listStyleType: "disc" }}>
                      <li className="mb-2">
                        <strong>3.2.a.</strong> Permite la recaudación y pago de facturas mensuales de telecomunicaciones (Cantv, Movistar, Digitel, Movilnet, Netuno, Inter, SimpleTV, Corpoelec) y otros servicios públicos/privados disponibles en la Aplicación.
                      </li>
                      <li className="mb-2">
                        <strong>3.2.b.</strong> Este servicio no conlleva un fee adicional para el Usuario.
                      </li>
                    </ul>

                    <h6 className="mb-2" style={{ fontWeight: "bold" }}>
                      3.3. Parquímetros:
                    </h6>
                    <ul className="pl-3" style={{ paddingLeft: "", listStyleType: "disc" }}>
                      <li className="mb-2">
                        <strong>3.3.a.</strong> Permite al Usuario pagar por el puesto de estacionamiento ocupado en zonas reguladas con parquímetros digitales, a través de la lectura de códigos QR en la Aplicación.
                      </li>
                      <li className="mb-2">
                        <strong>3.3.b.</strong> Este servicio no conlleva un fee adicional para el Usuario.
                      </li>
                    </ul>

                    <h6 className="mb-2" style={{ fontWeight: "bold" }}>
                      3.4. Pagos (Marketplace para Comercios y Personas):
                    </h6>
                    <ul className="pl-3" style={{ paddingLeft: "", listStyleType: "disc" }}>
                      <li className="mb-2">
                        <strong>3.4.a.</strong> Para Comercios: Permite recibir, enviar pagos y facturar a través de la Aplicación. Incluye:
                      </li>
                      <li className="mb-2">
                        <strong>3.4.b.</strong> Brazaletes (Wearable Tech): Permite realizar pagos cómodos y seguros con un toque.
                      </li>
                      <li className="mb-2">
                        <strong>3.4.c.</strong> Tap on Phone: Convierte cualquier smartphone en un punto de venta (PDV) sin hardware adicional.
                      </li>
                      <li className="mb-2">
                        <strong>3.4.d.</strong> Botón de Pago: Integración en la web o app del comercio para pagos a través de PagoDirecto.
                      </li>
                      <li className="mb-2">
                        <strong>3.4.e.</strong> Link de Pagos Digitales: Envío de solicitudes de pago por WhatsApp, correo o SMS.
                      </li>
                      <li className="mb-2">
                        <strong>3.4.f.</strong> Domiciliación de Pagos y Gestión de Cobranza: Herramientas para la gestión automatizada de cobros.
                      </li>
                      <li className="mb-2">
                        <strong>3.4.g.</strong> Ecommerce: Facilita transacciones en línea para comercios.
                      </li>
                      <li className="mb-2">
                        <strong>3.4.h.</strong> El servicio de Puntos de Venta (PDV) conlleva un fee de servicio de PagoDirecto de cero coma veinticinco dólares (USD 0.25) por transacción para el usuario. Otros servicios para comercios pueden tener comisiones y tarifas acordadas directamente con PagoDirecto.
                      </li>
                      <li className="mb-2">
                        <strong>3.4.i.</strong> Para Personas: Envío y recepción de fondos entre usuarios de PagoDirecto.
                      </li>
                    </ul>

                    <h6 className="mb-2" style={{ fontWeight: "bold" }}>
                      3.5. Seguros (RCV y Otros):
                    </h6>
                    <ul className="pl-3" style={{ paddingLeft: "", listStyleType: "disc" }}>
                      <li className="mb-2">
                        <strong>3.5.a.</strong> Facilita la renovación y adquisición de pólizas de Responsabilidad Civil de Vehículos (RCV), otros seguros y servicios de salud.
                      </li>
                      <li className="mb-2">
                        <strong>3.5.b.</strong> Ofrece funcionalidades como navegador de tipos de seguros, recordatorio de pago, domiciliación de cuotas y alertas al Usuario.
                      </li>
                      <li className="mb-2">
                        <strong>3.5.c.</strong> Este servicio no conlleva un fee adicional para el Usuario.
                      </li>
                    </ul>

                    <h6 className="mb-2" style={{ fontWeight: "bold" }}>
                      3.6. Peajes:
                    </h6>
                    <ul className="pl-3" style={{ paddingLeft: "", listStyleType: "disc" }}>
                      <li className="mb-2">
                        <strong>3.6.a.</strong> Agiliza el paso de conductores por los peajes aliados utilizando tecnología Bluetooth a través de la Aplicación.
                      </li>
                      <li className="mb-2">
                        <strong>3.6.b.</strong> Este servicio no conlleva un fee adicional para el Usuario.
                      </li>
                    </ul>
                    

                    <h6 className="mb-2" style={{ fontWeight: "bold" }}>
                      3.7. Eventos:
                    </h6>
                    <ul className="pl-3" style={{ paddingLeft: "", listStyleType: "disc" }}>
                      <li className="mb-2">
                        <strong>3.7.a.</strong> Impulsa la venta y simplifica la compra de tickets/entradas para eventos a través de la Aplicación, generando e-Tickets y códigos QR.
                      </li>
                      <li className="mb-2">
                        <strong>3.7.b.</strong> Este servicio no conlleva un fee adicional para el Usuario.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="mb-4">
                  <h2
                    className="mb-3 btn  "
                    style={{ textAlign: "left", alignSelf: "flex-start" }}
                  >
                    4. MÉTODOS DE PAGO Y PROCESAMIENTO
                  </h2>
                  <p>
                    <strong>4.1.</strong> PagoDirecto integra múltiples bancos y facilitador de métodos de recaudación electrónica a través de su aplicativo móvil. El Usuario debe vincular sus cuentas bancarias o tarjetas de débito/crédito según las opciones disponibles en la Aplicación.
                  </p>
                  <p>
                    <strong>4.2.</strong> Al realizar un pago, el Usuario autoriza a PagoDirecto a procesar la transacción a través de sus aliados bancarios y plataformas de pago.
                  </p>
                  <p>
                    <strong>4.3.</strong> Las tarifas y comisiones aplicables a los aliados (comercios, estacionamientos, proveedores de servicios, etc.) serán las acordadas en contratos individuales entre PagoDirecto y dichos aliados, y no afectarán directamente al Usuario, salvo los fees de servicio explícitamente mencionados para el Usuario.
                  </p>
                </div>

                <div className="mb-4">
                  <h2
                    className="mb-3 btn  "
                    style={{ textAlign: "left", alignSelf: "flex-start" }}
                  >
                    5. OBLIGACIONES Y RESPONSABILIDADES DEL USUARIO
                  </h2>
                  <p>
                    <strong>5.1.</strong> El Usuario se compromete a utilizar la Aplicación de manera lícita, ética y de acuerdo con estos Términos y la normativa venezolana aplicable.
                  </p>
                  <p>
                    <strong>5.2.</strong> El Usuario es el único responsable de la exactitud de la información proporcionada para sus transacciones y del uso correcto de las funciones de la Aplicación.
                  </p>
                  <p>
                    <strong>5.3.</strong> El Usuario no deberá:
                  </p>
                  <ul className="pl-3" style={{ paddingLeft: "", listStyleType: "disc" }}>
                    <li className="mb-2">
                      <strong>5.3.a.</strong> Utilizar la Aplicación para fines ilícitos, fraudulentos o no autorizados.
                    </li>
                    <li className="mb-2">
                      <strong>5.3.b.</strong> Intentar acceder o manipular los sistemas de PagoDirecto o la información de otros usuarios.
                    </li>
                    <li className="mb-2">
                      <strong>5.3.c.</strong> Realizar ingeniería inversa, descompilar o desensamblar cualquier parte de la Aplicación.
                    </li>
                    <li className="mb-2">
                      <strong>5.3.d.</strong> Infringir los derechos de propiedad intelectual de PagoDirecto o de terceros.
                    </li>
                  </ul>
                </div>

                <div className="mb-4">
                  <h2
                    className="mb-0 btn  "
                    style={{ textAlign: "left", alignSelf: "flex-start" }}
                  >
                    6. PROPIEDAD INTELECTUAL
                  </h2>
                  <p>
                    <strong>6.1.</strong> Todos los derechos de propiedad intelectual sobre la Aplicación PagoDirecto, incluyendo su código fuente, diseño, marcas, logotipos, contenidos y funcionalidades, son propiedad exclusiva de PAGODIRECTO LLC o de sus licenciantes.
                  </p>
                  <p>
                    <strong>6.2.</strong> La licencia de uso de la Aplicación es personal, no exclusiva, intransferible y revocable, limitada al uso de los servicios ofrecidos en conformidad con estos Términos.
                  </p>
                </div>

                <div className="mb-4">
                  <h2
                    className="mb-0 btn  "
                    style={{ textAlign: "left", alignSelf: "flex-start" }}
                  >
                    7. PRIVACIDAD DE DATOS
                  </h2>
                  <p>
                    <strong>7.1.</strong> El tratamiento de los datos personales del Usuario se regirá por la Política de Privacidad de PagoDirecto, disponible en [Insertar enlace a la Política de Privacidad]. Al aceptar estos Términos, el Usuario también acepta nuestra Política de Privacidad.
                  </p>
                  <p>
                    <strong>7.2.</strong> PagoDirecto implementa medidas de seguridad razonables para proteger la información del Usuario, pero no puede garantizar la seguridad absoluta de las transmisiones de datos a través de internet.
                  </p>
                  <p>
                    <strong>7.3.</strong> PagoDirecto garantiza el cumplimiento con la normativa de protección de datos y adopta protocolos de seguridad avanzados, incluyendo el cifrado de extremo a extremo para la transmisión de datos sensibles y almacenamiento seguro en servidores con certificaciones internacionales.
                  </p>
                  <p>
                    <strong>7.4.</strong> El Usuario podrá solicitar la eliminación de su información personal conforme a la normativa de privacidad vigente, a través de los canales establecidos en la Política de Privacidad.
                  </p>
                </div>

                <div className="mb-4">
                  <h2
                    className="mb-0 btn  "
                    style={{ textAlign: "left", alignSelf: "flex-start" }}
                  >
                    8. EXCLUSIÓN DE GARANTÍAS Y LIMITACIÓN DE RESPONSABILIDAD
                  </h2>
                  <p>
                    <strong>8.1.</strong> La Aplicación se proporciona "tal cual" y "según disponibilidad", sin garantías de ningún tipo, expresas o implícitas. PagoDirecto no garantiza que la Aplicación será ininterrumpida, libre de errores o que cualquier defecto será corregido.
                  </p>
                  <p>
                    <strong>8.2.</strong> PagoDirecto no será responsable por daños indirectos, incidentales, especiales, consecuenciales o punitivos, incluyendo pérdida de beneficios o datos, derivados del uso o la imposibilidad de uso de la Aplicación, incluso si ha sido informado de la posibilidad de tales daños.
                  </p>
                  <p>
                    <strong>8.3.</strong> La responsabilidad máxima de PagoDirecto en cualquier caso se limitará al monto total de los fees de servicio pagados por el Usuario a PagoDirecto en los tres (3) meses anteriores a la reclamación.
                  </p>
                </div>

                <div className="mb-4">
                  <h2
                    className="mb-0 btn  "
                    style={{ textAlign: "left", alignSelf: "flex-start" }}
                  >
                    9. PLATAFORMA DE RECAUDACIÓN Y NATURALEZA DEL SERVICIO DE PAGODIRECTO LLC
                  </h2>
                  <p>
                    El USUARIO es del conocimiento que PAGODIRECTO LLC, en su carácter de empresa dedicada al desarrollo de soluciones tecnológicas, actúa exclusivamente como facilitador de métodos de recaudación electrónica a través de su aplicativo móvil. En tal sentido, PAGODIRECTO LLC provee a los ESTACIONAMIENTO y a los USUARIOS una plataforma tecnológica que permite la gestión, procesamiento y canalización de los pagos asociados a la adquisición de tickets digitales y/o físicos para el ingreso, permanencia y egreso de vehículos en las instalaciones del estacionamiento.
                  </p>
                  <p>
                    A través de la aplicación móvil de PAGODIRECTO LLC, los USUARIOS podrán realizar el pago correspondiente al servicio de estacionamiento por los diferentes métodos de recaudación electrónica de su elección, cuyos fondos son recaudados directamente en las cuentas control de los bancos autorizados o cuentas transitorias, previamente definidas de común acuerdo con los ESTACIONAMIENTOS autorizados. En ningún caso PAGODIRECTO LLC interviene como agente recaudador, custodio de fondos, ni como entidad financiera, limitándose a proveer la infraestructura tecnológica que interconecta al usuario con los mecanismos bancarios de pagos de su elección.
                  </p>
                  <p>
                    Asimismo, EL USUARIO deja constancia de que el uso de esta plataforma es opcional, quienes podrán efectuar el pago del servicio mediante los canales regulares, conforme a las condiciones y medios disponibles al momento de su utilización y/o ingreso al ESTACIONAMIENTO.
                  </p>
                  <p>
                    Tanto EL USUARIO, PAGODIRECTO LLC y el ESTACIONAMIENTO reconocen y aceptan su respectiva responsabilidad en el cumplimiento de las obligaciones fiscales aplicables, incluyendo el pago de los tributos nacionales, estadales o municipales que les correspondan a cada uno y de manera individual, conforme al marco normativo vigente.
                  </p>
                  <p>
                    Se deja expresamente establecido que las cuentas control y/o transitorias en las que se consolidan los fondos no están a nombre de PAGODIRECTO LLC, sino que corresponden a cuentas gestionadas directamente por entidades financieras autorizadas y debidamente registradas ante la Superintendencia de las Instituciones del Sector Bancario (SUDEBAN). Por tanto, PAGODIRECTO LLC no es responsable por retrasos en la acreditación de los fondos una vez estos hayan ingresado a las mencionadas cuentas, derivados de fallas técnicas, interrupciones en los sistemas bancarios o cualquier otro evento imputable a las instituciones financieras involucradas.
                  </p>
                </div>

                <div className="mb-4">
                  <h2
                    className="mb-0 btn  "
                    style={{ textAlign: "left", alignSelf: "flex-start" }}
                  >
                    10. CUENTAS TRANSITORIAS Y ESQUEMA DE MOVILIZACIÓN DE FONDOS
                  </h2>
                  <p>
                    Es del conocimiento de EL USUARIO, que a los fines de la correcta implementación del modelo de pago electrónico, se define como cuenta transitoria aquella cuenta habilitada y administrada por la entidad bancaria autorizada, en la cual se consolida temporalmente el flujo de fondos derivados de las transacciones efectuadas por los USUARIOS del ESTACIONAMIENTO a través de los mecanismos de recaudación de los bancos autorizados.
                  </p>
                  <p>
                    Estas cuentas permiten la operación de un esquema de cash-in/cash-out, mediante el cual se canalizan pagos realizados desde instituciones financieras distintas a la cuenta recaudadora principal, permitiendo su posterior dispersión hacia las cuentas bancarias individuales de los distintos comercios o establecimientos afiliados.
                  </p>
                  <p>
                    PAGODIRECTO LLC indicará cómo deberán ser dispersados los fondos recibidos, de conformidad con los acuerdos previamente definidos, y deja constancia que no tiene acceso, control ni facultad de disposición sobre los fondos mantenidos en dichas cuentas transitorias, actuando exclusivamente como proveedor de la herramienta tecnológica que viabiliza la trazabilidad y conciliación de los fondos, de conformidad con los protocolos de seguridad y operatividad definidos por la entidad financiera responsable.
                  </p>
                </div>

                <div className="mb-4">
                  <h2
                    className="mb-0 btn  "
                    style={{ textAlign: "left", alignSelf: "flex-start" }}
                  >
                    11. RESPONSABILIDAD POR SERVICIOS DE TERCEROS
                  </h2>
                  <p>
                    PagoDirecto actúa como un intermediario tecnológico que facilita transacciones y pagos digitales, pero no se hace responsable por interrupciones, retrasos o errores en las operaciones derivadas de fallos en los sistemas de bancos, procesadores de pago o proveedores de servicios externos.
                  </p>
                </div>

                <div className="mb-4">
                  <h2
                    className="mb-0 btn  "
                    style={{ textAlign: "left", alignSelf: "flex-start" }}
                  >
                    12. MODIFICACIONES DE LOS TÉRMINOS Y CONDICIONES
                  </h2>
                  <p>
                    PagoDirecto se reserva el derecho de modificar o actualizar estos Términos y Condiciones en cualquier momento. Cualquier modificación será efectiva desde su publicación en la Aplicación. Se recomienda al Usuario revisar periódicamente los Términos. El uso continuado de la Aplicación después de la publicación de las modificaciones constituirá la aceptación de los nuevos Términos. Cualquier cambio será notificado a los Usuarios mediante la Aplicación antes de su entrada en vigor.
                  </p>
                </div>

                <div className="mb-4">
                  <h2
                    className="mb-0 btn  "
                    style={{ textAlign: "left", alignSelf: "flex-start" }}
                  >
                    13. CUMPLIMIENTO NORMATIVO Y REGULATORIO
                  </h2>
                  <p>
                    PagoDirecto cumple con las normativas vigentes en Venezuela relacionadas con los servicios tecnológicos. Asimismo, los servicios dentro de la Aplicación se ajustan a las disposiciones sobre prevención de legitimación de capitales y financiamiento al terrorismo.
                  </p>
                </div>

                <div className="mb-4">
                  <h2
                    className="mb-0 btn  "
                    style={{ textAlign: "left", alignSelf: "flex-start" }}
                  >
                    14. LEY APLICABLE Y JURISDICCIÓN
                  </h2>
                  <p>
                    Los presentes Términos y Condiciones se rigen e interpretan de conformidad con las leyes de la República Bolivariana de Venezuela. Cualquier disputa o controversia que surja en relación con estos Términos será sometida a la jurisdicción exclusiva de los tribunales competentes de la ciudad de Caracas, Venezuela, renunciando a cualquier otro fuero que pudiera corresponder.
                  </p>
                </div>

                <div className="mb-4">
                  <h2
                    className="mb-0 btn  "
                    style={{ textAlign: "left", alignSelf: "flex-start" }}
                  >
                    15. CONTACTO
                  </h2>
                  <p>
                    Si tiene alguna pregunta o inquietud sobre estos Términos y Condiciones, puede contactarnos a través de los canales de soporte disponibles en la Aplicación o en nuestro sitio web oficial.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div style={{ height: "500px" }}></div>
        </div>
      </section>
    </>
  );
};

export default Main;
